import request from '@/utils/request';
import { ApiDef, ApiObject } from 'aegis-api-proxy';

import definition from './api-definition';

export function getAccidentRoom() {
  return request({
    url: 'video/trtc/available_calls',
    method: 'get'
  });
}

export function reEnterAccidentRoom(accidentId: string) {
  return request({
    url: '/video/trtc/reEnter',
    method: 'get',
    params: { accidentId }
  });
}

export function exitAccidentRoom(accidentId: string, agentUserName: string) {
  return request({
    url: '/video/trtc/exit',
    method: 'get',
    params: { accidentId, agentUserName }
  });
}
// 获取新建工单id 
export function getCreateAccidentBy5G( phoneNumber:string, extension: string) {
  return request({
    url: '/video/trtc/getCreateAccidentBy5G',
    method: 'get',
    params: { phoneNumber, extension }
  });
}
export default Object.assign({}, definition) as ApiObject<ApiDef>;
